<!-- 销售合同 -->
<template>
  <div class='page_content'>

    <el-dialog title="回执登记" :visible.sync="showStatus" width="60%">
      <el-form size="mini" id="mainInfo" label-width="120px">
        <el-form-item label="登记时间">
          <label slot="label" :style="$common.labelStyle('登记时间')" v-html="'登记时间'"></label>
          <el-date-picker v-model="sendDataInfo.receiptDate" value-format="timestamp" style="width: 100%;" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <label slot="label" :style="$common.labelStyle('备注')" v-html="'备注'"></label>
          <el-input v-model.trim="sendDataInfo.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
    <contractFile ref="contractFile"></contractFile>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" v-if="pageShowData.jurTableVo" @selection-change="selectChange" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column v-if="tableValye.isShow == 1" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'formatter'">
              <span v-for="item in JSON.parse(tableValye.formatterContent)">
                <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">
                  {{ item.value }}
                </el-tag>
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
            </span>
            <!-- <span v-else-if="tableValye.fieldType == 'date'">
              {{ scope.row[tableValye.entityField] ?
                                        $common.getLocalTime(scope.row[tableValye.entityField]) : ''
                                    }}
            </span> -->
            <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog title="登记销售合同" :visible.sync="dialogPs" width="400px">
      <el-form>
        <el-form-item label="登记金额">
          <el-input type="number" v-model="conmMoney" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPs = false">取 消</el-button>
        <el-button type="primary" @click="conRegister">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
    <printPlan ref="printPlan"></printPlan>

  </div>
</template>

<script>
import VSearch from '../../../byComponents/vSearch.vue';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import contractFile from "@/components/contractFile.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { VSearch,contractFile },

  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        page: 1,
        rows: 30,
        start: '',
        end: '',
        cmId: '',
        cmName: '',
        businessId: '',
        conmState: 0,
        "creater": 0,
        "ormId": 0,
        "status": '',
        "wobkemId": ""
      },
      sendDataInfo: {
        "receiptDate": new Date().getTime(),
        "remark": "",
        "ids": ""
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: []
      },
      buttonList: [],
      selectData: [],
      pageShowData: [],
      formDataList: [],
      selectedDataIndex: 0,
      actionData: {},
      showStatus: false,
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogExtract: false,
      seType: "",
      cmId: "",
      parentSearchData: {},
      conmMoney: '', //登记金额
      dialogPs: false,
      conmId: '',
      requesUrl: '',
      imgUrl: '',
      sField: ''
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.cmName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.cmId = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    cancel() {
      this.showStatus = false
      this.sendDataInfo = {
        "receiptDate": new Date().getTime(),
        "remark": "",
        "ids": ""
      }
    },
    sure() {
      this.$http.updatecontractsign(this.sendDataInfo).then(res => {
        if (res.status == 200) {
          this.showStatus = false
          this.getDataList()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 登记合同
    async conRegister() {
      if (this.conmMoney == '') {
        return this.$message({
          message: '请填写登记金额',
          type: 'warning'
        });
      }
      let data = {
        conmMoney: this.conmMoney,
        conmId: this.conmId
      }
      let responseData = await this.$http.regContract(data)
      if (responseData.status == 200) {
        this.$message({
          message: '登记成功',
          type: 'success'
        });
        this.dialogPs = false
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    selectChange(val) {
      this.selectData = val
    },
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.seId = sId;
      this.sField = sField
      this.DialogVisible = true;
      this.parentSearchData[type] = this.getRequestData[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    // 子组件触发
    drawerCancel(e) {
      this.showStatus = false;
      if (e == 1) this.getDataList();
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({
          //向窗口发送MessageEvent消息
          cmd: "returnFormJson",
          params: {
            isPenetrate
          }, //参数
        },
          "*"
        );
      }
    },
    pictureShow(data) {
      var imgList = []
      data.forEach(item => {
        imgList.push(this.$store.getters.getConfig.imgUrl + item.claFilepath)
      })

      return imgList
    },
    isShowData(name, value) {
      this.sendDataInfo[name] = value
    },
    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      })
      if (responseData.status == 200) {
        this.getButtonList()
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      console.log(actionData.actionType);
      switch (actionData.actionType) {
        case 0:
          if (this.selectData.length != 0) {
            var arr = []
            this.selectData.forEach(item => {
              arr.push(item.wobkemId)
            })
            sessionStorage.setItem("contractIds", JSON.stringify(arr))
            this.showPrintPlan()
          } else {
            this.$message({
              message: '请至少选择一条数据！',
              type: 'error'
            });
          }
          // logisticsNum
          // printKdnStatusUrl()
          break;
        case 8:
          if (this.selectData.length != 0) {

            this.sendDataInfo.ids = this.selectData.map(item => item.wobkemId)
            this.showStatus = true

          } else {
            this.$message({
              message: '请先选择数据！',
              type: 'error'
            });
          }

          break;
      }
    },
    showPrintPlan() {
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        var info = this.selectData.map(item => item.wobkemId)
        // 1
        this.$refs.printPlan.openDia(info, "/printData/suOrderBookkeeping", sessionStorage.getItem('printJurId'), '', 'all')
      } else {
        return
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    openRegis() {
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      this.conmId = dataInfo.conmId
      this.conmMoney = ''
      this.dialogPs = true
    },
    //   下载压缩包
    downLoadFile() {
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      // window.location.href = this.requesUrl + '/psaccount/downDetailFile?url=' + e
      window.location.href = this.requesUrl + '/sucontract/downloadContract?ids=' + dataInfo.conmId
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },


    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.queryContractsign(this.getRequestData)
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },


    // 删除数据
    delDataAction() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: '暂无数据',
            type: 'error'
          });
          return false
        }
      }
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: '请先选择您要操作的数据',
          type: 'error'
        });
        return false
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: [dataInfo.conmId]
        }
        let responseData = await this.$http.deletesucontract(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });

    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
//获取图片存取的根路径
    imgurl() {
      // console.log(this.$store.getters.getConfig);
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
    initTime() {
      this.getRequestData.start = this.$common.getStartTime()
      this.getRequestData.end = this.$common.getEndTime()
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()
    this.imgurl()
    this.initTime()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>